import { useAppDispatch } from "../../../../../redux/hooks";
import {
  fetchPrintBinA4,
  fetchPrintBinZebra,
  fetchUndeliveredBins,
  postDeleteBin,
} from "../../../../../redux/api/expedition.api";
import { UndeliveredBinsDataInterface } from "../../../../../redux/interfaces/expedition.interface";

import ActionMenu from "../../../../../components/actionMenu/ActionMenu";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../../helpers/apiHelper";
import { useState } from "react";

function UndeliveredBinsActionButtons({
  itemId,
  crudData,
  tableContext,
}: {
  itemId: string;
  crudData: UndeliveredBinsDataInterface;
  tableContext?: any;
}) {
  const dispatch = useAppDispatch();

  const [isLoading, setIsLoading] = useState(false);

  const handlePrintBinA4 = () => {
    if (itemId) {
      dispatch(
        fetchPrintBinA4({
          idBin: itemId,
        }),
      );
    }
  };

  const handlePrintBinZebra = () => {
    if (itemId) {
      dispatch(
        fetchPrintBinZebra({
          idBin: itemId,
        }),
      );
    }
  };

  const handleDeleteBin = async () => {
    const resultAction = await dispatch(
      postDeleteBin({
        id_bin: crudData.id_bin,
      }),
    );

    if (
      checkEndpointStatus(resultAction, postDeleteBin) !==
      endpointStatus.pending
    ) {
      setIsLoading(false);
    }

    if (
      checkEndpointStatus(resultAction, postDeleteBin) ===
      endpointStatus.fulfilled
    ) {
      dispatch(
        fetchUndeliveredBins({
          page: tableContext.tablePagination.page,
          perPage: tableContext.tablePagination.rowsPerPage,
          sn_bin: tableContext.tableSearch.sn_bin,
          nodDestinatie: tableContext.tableSearch.nodDestinatie,
          nodPreluare: tableContext.tableFilter.nodPreluare,
          status: tableContext.tableFilter.status,
        }),
      );
    }
  };

  return (
    <ActionMenu
      minItemsForMenu={2}
      title={`BIN ${crudData.sn_bin}`}
      ariaLabel={`Actiuni pentru BIN ${crudData.sn_bin}`}
      items={[
        {
          id: "print-a4",
          label: "Print A4",
          icon: "PRINT_A4",
          kind: "print",
          section: "browse",
          tooltip: "Descarca eticheta BIN in format PDF A4.",
          onClick: handlePrintBinA4,
        },
        {
          id: "print-zebra",
          label: "Print Zebra",
          icon: "PRINT_ZEBRA",
          kind: "print",
          section: "browse",
          tooltip: "Tipareste eticheta BIN la imprimanta Zebra.",
          onClick: handlePrintBinZebra,
        },
        {
          id: "delete-bin",
          label: "Stergere",
          icon: "DELETE",
          color: "error",
          section: "danger",
          dividerBefore: true,
          loading: isLoading,
          hidden: crudData.status !== 0,
          tooltip: "Sterge definitiv BIN-ul selectat.",
          withConfirmationModal: {
            modalTitle: `Doriti sa stergeti binul ${crudData.sn_bin}?`,
            modalLeftButtonColor: "inherit",
            modalRightButtonOnClick: handleDeleteBin,
            modalRightButtonText: "Sterge",
            modalLeftButtonText: "Anuleaza",
          },
        },
      ]}
    />
  );
}

export default UndeliveredBinsActionButtons;
